<template>
  <b-card header-bg-variant="custom" no-body>
    <template #header>
      <h4 class="text-white">{{ title }}</h4>
    </template>
    <b-card-body>
      <b-row>
        <b-col class="col-12" v-if="periodInfo">
          <p class="text-muted">{{ periodInfo }}</p>
        </b-col>
        <b-col class="col-12">
          <apexchart
            :key="this.selected"
            :type="chart.type"
            :options="chart.options"
            :series="chart.data"
            :height="options.chart.height"
          ></apexchart>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    chartType: { type: String, required: true },
    options: { type: Object, required: true },
    data: { type: Array, required: true },
    periodInfo: { type: String, default: null },
    defaultIndicator: { type: String, default: "totalVisitors" },
    selectChoice: { type: Boolean, default: false },
  },
  data() {
    return {
      card: {
        title: null,
      },
      chart: {
        type: null,
        options: null,
        data: null,
      },
      selectOptions: [
        { value: "totalVisitors", text: this.$t("indicators.totalVisitors") },
        { text: this.$t("indicators.overnights"), value: "overnights" },
        { text: this.$t("indicators.dayTrippers"), value: "dayTrippers" },
      ],
      selected: null,
    };
  },
  created() {
    this.card.title = this.title;
    this.chart.type = this.chartType;
    this.chart.options = this.options;
    this.chart.data = this.data;
    this.selected = this.defaultIndicator;
  },
  methods: {
    transmitNewValue() {
      this.$emit("weekdayIndicator", this.selected, "indicator");
    },
  },
};
</script>
